import { Chip } from "@mui/material";

const statusMap = {

    "-1": {
        label: "Cancelled",
        color: "#ef4444"
    },

    0: {
        label: "Booked",
        color: "#64748b"
    },

    1: {
        label: "Assigned",
        color: "#f97316"
    },

    2: {
        label: "Picked Up",
        color: "#fb923c"
    },

    3: {
        label: "Warehouse",
        color: "#ea580c"
    },

    4: {
        label: "Shipped",
        color: "#3b82f6"
    },

    5: {
        label: "Received",
        color: "#2563eb"
    },

    6: {
        label: "Out For Delivery",
        color: "#16a34a"
    },

    7: {
        label: "Delivered",
        color: "#15803d"
    },

    8: {
        label: "Partially Delivered",
        color: "#eab308"
    }

};

const StatusChip = ({ status }) => {

    const item = statusMap[status];

    return (<Chip
        label={item?.label}
        sx={{
            background: item?.color,
            color: "#fff",
            fontWeight: 600,
            borderRadius: "8px"
        }}
    />);

};

export default StatusChip;